"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @private
 */
exports.AGENT_ENDPOINT = {
    getOperators: '/user-company/backoffice/agents/cs-operators',
};
